module.exports = __webpack_public_path__ + "img/form.92a8194a.svg";